__turbopack_context__.v({
  "anchor": "public-profile-module-scss-module__lmLVzW__anchor",
  "button": "public-profile-module-scss-module__lmLVzW__button",
  "chevron": "public-profile-module-scss-module__lmLVzW__chevron",
  "footer": "public-profile-module-scss-module__lmLVzW__footer",
  "fullscreen": "public-profile-module-scss-module__lmLVzW__fullscreen",
  "more": "public-profile-module-scss-module__lmLVzW__more",
  "profile": "public-profile-module-scss-module__lmLVzW__profile",
});
